/**
 * PriceBlock — launch-offer price display (Command 03 §2/§5).
 * "Regular Price ₹99" struck through, offer price prominent,
 * "Launch Offer" label. No countdowns, no artificial scarcity.
 * Optional accentColor/offerChipColor/regularPriceLabel/savings props let
 * other LifeIQ imprints (e.g. Cyber Safety) reuse this unchanged with
 * their own palette — defaults preserve Chinnu's exact original look.
 */
export default function PriceBlock({
  product,
  dark = false,
  big = false,
  testId,
  accentColor = "#F57F17",
  offerChipColor = "#F5B25C",
  regularPriceLabel = "Regular Price",
  savings,
}) {
  return (
    <div data-testid={testId}>
      <div className="flex items-baseline gap-2.5">
        <span className={`text-[11px] uppercase tracking-[0.18em] font-semibold ${dark ? "text-white/55" : "text-[#5C6470]"}`}>
          {regularPriceLabel}
        </span>
        <span
          className={`line-through decoration-2 ${dark ? "text-white/40" : "text-[#9AA1AB]"} ${big ? "text-[19px]" : "text-[15px]"}`}
          style={{ textDecorationColor: `${accentColor}B3` }}
        >
          {product.regular_price}
        </span>
      </div>
      <div className="mt-1.5 flex items-end gap-3">
        <span className={`font-serif-d leading-none ${big ? "text-[44px] sm:text-[52px]" : "text-[32px]"} ${dark ? "text-white" : "text-[#0D1B2A]"}`}>
          {product.price}
        </span>
        <span
          className={`${big ? "pb-2" : "pb-1.5"} text-[10px] sm:text-[11px] uppercase tracking-[0.14em] font-bold text-[#0D1B2A] px-2.5 py-1 rounded-sm`}
          style={{ backgroundColor: offerChipColor }}
        >
          {product.offer_label}
        </span>
        {savings && (
          <span className={`${big ? "pb-2" : "pb-1.5"} text-[10px] sm:text-[11px] uppercase tracking-[0.14em] font-bold`} style={{ color: accentColor }}>
            Save {savings}
          </span>
        )}
      </div>
    </div>
  );
}
